import { APP_CONFIG } from '../../../config';
import { Country } from './Country.model';
import { useApiGet } from '../../../api/api.hooks';

export function useCountries() {
  return useApiGet<Country[]>(APP_CONFIG.api.accountAddress.countries);
}
